var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"palyer2",staticStyle:{"width":"512px","height":"300px","margin":"auto"}},[_c('LivePlayer',{ref:"player2",attrs:{"videoUrl":_vm.videoUrl,"live":""},on:{"snapOutside":_vm.snapOutside}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79405884","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/LivePlayerDemo.vue
// module id = null
// module chunks = 